import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/4d8c8f6f/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentDemo = makeShortcode("ComponentDemo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <ComponentDemo links={{
      React: 'https://react.carbondesignsystem.com/?path=/story/pagination--pagination',
      Angular: 'https://angular.carbondesignsystem.com/?path=/story/components-pagination--basic',
      Vue: 'http://vue.carbondesignsystem.com/?path=/story/components-cvpagination--default',
      Vanilla: 'https://the-carbon-components.netlify.com/?nav=pagination'
    }} knobs={{
      Pagination: ['disabled', 'isLastPage', 'pageInputDisabled', 'pagesUnknown']
    }} mdxType="ComponentDemo">
  {`
  <div style={{width: '800px'}}>
    <Pagination
      backwardText="Previous page"
      forwardText="Next page"
      itemsPerPageText="Items per page:"
      page={1}
      pageNumberText="Page Number"
      pageSize={10}
      pageSizes={[
        10,
        20,
        30,
        40,
        50
      ]}
      totalItems={103}
    />
  </div>
  `}
    </ComponentDemo>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      